/**
 * Created by admin on 2018/1/26.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Radio, Switch, Icon, Select } from 'antd';

const { Option } = Select;
const subLanguage = [
  {id: 'Mandarin_China_Simplified', var: 'mc_subtitle_language_zh'},
  {id: 'English_US', var: 'mc_subtitle_language_en_u'},
  {id: 'Korean', var: 'mc_subtitle_language_kr'},
  {id: 'Japanese', var: 'mc_subtitle_language_jp'},
  {id: 'Malay', var: 'mc_subtitle_language_my'}
];
const defalutState = {
  asrLanguage: 'Mandarin_China_Simplified',
  asrTranslatedLanguage:'',
  asrAlternativeLanguages:[]
};

export default class SubtitleMinutes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...defalutState};
  }

  componentWillReceiveProps(nextProps) {
    const { visible } = nextProps;
    !visible && this.setState({...defalutState});
  }

  render() {
    const { intl, onSubmit, onCancel } = this.props;
    const { asrLanguage, asrTranslatedLanguage, asrAlternativeLanguages } = this.state;

    const options = subLanguage.map(s=>{
      const forbidden =
        asrAlternativeLanguages.length >= 2 &&
        !asrAlternativeLanguages.some(al=>al===s.id);
      return (
        <Option disabled={forbidden} key={s.id}>
          <FormattedMessage id={s.var} />
        </Option>
      )
    })

    return (
      <div className={'subtitle-minutes-container'}>
        <div className={'opt-line'}>
          <div className={'opt-label'}>
            <FormattedMessage id="mc_subtitle_language" />:
          </div>
          <div className={'opt-value'}>
          <Radio.Group
            value={asrLanguage}
            onChange={e=>this.setState({asrLanguage:e.target.value})}
          >
            <Radio value={'Mandarin_China_Simplified'}>
              <FormattedMessage id="mc_subtitle_language_zh" />
            </Radio>
            <Radio value={'English_US'}>
              <FormattedMessage id="mc_subtitle_language_en_u" />
            </Radio>
            {/* <Radio value={'English_US'}>
              <FormattedMessage id="mc_subtitle_language_en_a" />
            </Radio> */}
          </Radio.Group>
          </div>
        </div>
        <div className={'opt-line'}>
          <div className={'opt-label'}>
            <FormattedMessage id="mc_subtitle_translate" />:
          </div>
          <div className={'opt-value'}>
            <Switch
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="close" />}
              checked={asrTranslatedLanguage !== ''}
              onChange={checked=>
                this.setState({asrTranslatedLanguage:checked?'English_US':''})
              }
            />
          </div>
        </div>
        <div className={'opt-line'}>
          <div className={'opt-label'}>
            <FormattedMessage id="mc_subtitle_sublanguage" />:
          </div>
          <div className={'opt-value'}>
          <Select
            allowClear
            mode="multiple"
            style={{ width: '100%' }}
            placeholder={intl.formatMessage({ id: 'mc_subtitle_google' })}
            value={asrAlternativeLanguages}
            onChange={(value)=>this.setState({asrAlternativeLanguages:value})}
          >
            {options}
          </Select>
          </div>
        </div>
        <div className={'opt-footer'}>
          <div className={'opt-btn'} onClick={()=>onSubmit(this.state)}>
            <FormattedMessage id="mc_btn_ok" />
          </div>
          <div className={'opt-btn'} onClick={()=>onCancel()}>
            <FormattedMessage id="mc_btn_cancel" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SubtitleMinutes.js